/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.tw1

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.tw1Routing(app: App): Navigo {
  return on("/tytul_wykonawczy_nowy/:token", { params ->
    Tw1Model.nowy(stringProperty(params, "token"), app)
  }).on("/tytul_wykonawczy_edycja/:token", { params ->
    Tw1Model.edycja(stringProperty(params, "token"), app)
  })
}
